/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type shifts_CheckConflictsRequest = {
    /**
     * Optional break in minutes, subtracted from the span for the day and week warnings (#2042). Missing = 0.
     */
    break_minutes?: number;
    /**
     * ID of the employee to check conflicts for. Empty for an open shift (open_shift = true).
     */
    employee_id?: string;
    /**
     * Several employees (#2121): each is checked on every day of the proposed shift or series and answered under employees. Exclusive with employee_id and open_shift.
     */
    employee_ids?: Array<string>;
    /**
     * End time in HH:MM 24-hour format (e.g., "16:00"). Local to the organization's timezone. Exclusive boundary for conflict detection.
     */
    end_time: string;
    /**
     * Optional shift ID to exclude from conflict check (useful when updating an existing shift)
     */
    exclude_id?: string;
    /**
     * True checks an open shift without an employee (#2040): no overlap and no availability entry;
     * the working time warnings count the shift alone. employee_id must then be empty.
     */
    open_shift?: boolean;
    /**
     * Optional recurrence of a proposed series (#2119): every day of the series is checked and the response lists the colliding days in conflict_dates and absent_dates. NONE or empty checks shift_date only.
     */
    recurrence_type?: shifts_CheckConflictsRequest.recurrence_type;
    /**
     * Repetitions of the proposed series (1-365); required with a recurrence_type other than NONE
     */
    repetitions?: number;
    /**
     * Date of the proposed shift in ISO 8601 format (YYYY-MM-DD), local to the organization's timezone
     */
    shift_date: string;
    /**
     * Start time in HH:MM 24-hour format (e.g., "08:00"). Local to the organization's timezone.
     */
    start_time: string;
    /**
     * ISO weekdays (1=Mon .. 7=Sun) of a CUSTOM_WEEKDAYS series
     */
    weekdays?: Array<number>;
};
export namespace shifts_CheckConflictsRequest {
    /**
     * Optional recurrence of a proposed series (#2119): every day of the series is checked and the response lists the colliding days in conflict_dates and absent_dates. NONE or empty checks shift_date only.
     */
    export enum recurrence_type {
        NONE = 'NONE',
        DAILY = 'DAILY',
        WEEKDAYS = 'WEEKDAYS',
        WEEKLY = 'WEEKLY',
        CUSTOM_WEEKDAYS = 'CUSTOM_WEEKDAYS',
    }
}

